export class CreateFromOrderBody {
    id: string;
    ignoreunavailableproducts: boolean;
}
